import { render, staticRenderFns } from "./VuesticChart.vue?vue&type=template&id=5ae34986"
import script from "./VuesticChart.vue?vue&type=script&lang=js"
export * from "./VuesticChart.vue?vue&type=script&lang=js"
import style0 from "./VuesticChart.vue?vue&type=style&index=0&id=5ae34986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-chart/VuesticChart.vue
// module id = tgcS
// module chunks = 41